import { IConfig } from "@kuika/kuika-cl-model";
import * as React from "react";
import { KuikaListTableRowAction } from "../../ui-kit/kuika-list-table/kuika-list-table";
import KuikaSvg from "../../ui-kit/kuika-svg/kuika-svg";
import { ConfigScope, isReadOnlyReference } from "./config-manager-model";

/**
 * What can be done to a configuration from a list of them: the landing table's row menu and the
 * editor switcher's "…" are this one list. A global row inside a project's list is a read-only
 * reference, and its one action is to start a project configuration from it.
 */

export interface IConfigRowActionHandlers {
  scope: ConfigScope;
  onCreateFromGlobal: (source: IConfig) => void;
  /** Omit where the surface has nowhere to send the write. */
  onRename?: (config: IConfig) => void;
  onDuplicate?: (config: IConfig) => void;
  /** Opens the host's confirmation; nothing is deleted until it is answered. */
  onRequestDelete: (config: IConfig) => void;
}

export const buildConfigRowActions = (handlers: IConfigRowActionHandlers): KuikaListTableRowAction<IConfig>[] => {
  const readOnly = (row: IConfig): boolean => isReadOnlyReference(handlers.scope, row);
  return [
    {
      key: "createFromGlobal",
      label: "Create config from this global config",
      // The derived id would be `dropdownCreateconfigfromthisglobalconfigButton`; this sentence is
      // a label, not a name.
      dataTestId: "dropdownCreateFromGlobalConfigButton",
      icon: <KuikaSvg width={16} height={16} name="copy" />,
      hidden: (row: IConfig) => !readOnly(row),
      onSelect: handlers.onCreateFromGlobal
    },
    {
      key: "rename",
      label: "Rename",
      icon: <KuikaSvg width={16} height={16} name="edit" />,
      hidden: (row: IConfig) => !handlers.onRename || readOnly(row),
      onSelect: (row: IConfig) => handlers.onRename?.(row)
    },
    {
      key: "duplicate",
      label: "Duplicate",
      icon: <KuikaSvg width={16} height={16} name="copy" />,
      hidden: (row: IConfig) => !handlers.onDuplicate || readOnly(row),
      onSelect: (row: IConfig) => handlers.onDuplicate?.(row)
    },
    {
      key: "delete",
      label: "Delete",
      icon: <KuikaSvg width={16} height={16} name="trash" />,
      danger: true,
      hidden: readOnly,
      onSelect: handlers.onRequestDelete
    }
  ];
};
